export const identificationDevice = (type: string): boolean => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(type)) {
        return true;
    }
    return false;
};
